import { Link } from 'react-router-dom';
import Icon from './Icon';
import { WHY } from '../data';
import { IMG, u } from '../images';

export default function WhyUs() {
  return (
    <section className="section bg-ink text-white">
      <div className="grid-bg pointer-events-none absolute inset-0" />
      <div className="pointer-events-none absolute -left-32 bottom-0 h-96 w-96 rounded-full bg-brand/40 blur-[120px]" data-parallax="0.3" />
      <div className="pointer-events-none absolute -right-32 top-0 h-80 w-80 rounded-full bg-brand-lime/10 blur-[120px]" data-parallax="-0.3" />

      <div className="container-x relative">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div className="max-w-2xl" data-anim="left">
            <span className="eyebrow eyebrow-dark">Why Origo</span>
            <h2 className="h2 mt-5">The <span className="text-accent-light">partner</span> that treats your product like <span className="text-outline-light">its own</span></h2>
          </div>
          <p className="max-w-md text-lg leading-relaxed text-white/65" data-anim="right">
            We are not a faceless outsourcing shop. You get a senior, accountable team, honest timelines and results you can measure.
          </p>
        </div>

        {/* bento: tall photo + six reasons */}
        <div className="mt-14 grid gap-5 lg:grid-cols-4" data-anim="up" data-stagger>
          <div className="group relative min-h-[340px] overflow-hidden rounded-[2rem] rounded-tl-[6rem] lg:col-span-2 lg:row-span-3">
            <img src={u(IMG.gallery[2], 1000)} alt="The Origo workspace" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-brand/20" />
            <div className="absolute inset-x-6 bottom-6 sm:inset-x-8 sm:bottom-8">
              <div className="inline-flex items-center gap-4 rounded-2xl border border-white/15 bg-ink/70 p-4 backdrop-blur-md">
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand-lime text-ink"><Icon name="star" className="h-6 w-6 fill-current" /></span>
                <span>
                  <span className="block font-display text-2xl font-bold">4.9 / 5</span>
                  <span className="text-sm text-white/60">average client satisfaction</span>
                </span>
              </div>
              <p className="mt-5 max-w-sm font-display text-xl font-semibold leading-snug sm:text-2xl">One senior team from the first call to launch day — and beyond.</p>
              <Link to="/contact" className="btn-primary mt-6">Work with us <Icon name="arrow" className="h-4 w-4" /></Link>
            </div>
          </div>

          {WHY.map((w, i) => (
            <div key={w.title} className="lift group relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] p-6 transition-colors hover:border-brand-lime/60 hover:bg-white/[0.08]">
              <span className="pointer-events-none absolute -right-2 -top-4 select-none font-display text-7xl font-bold text-white/[0.05] transition-colors group-hover:text-brand-lime/15">0{i + 1}</span>
              <span className="relative grid h-12 w-12 place-items-center rounded-2xl bg-brand-lime/15 text-brand-lime transition-colors group-hover:bg-brand-lime group-hover:text-ink"><Icon name={w.icon} /></span>
              <h3 className="relative mt-5 text-lg font-bold">{w.title}</h3>
              <p className="relative mt-2 text-[15px] leading-relaxed text-white/65">{w.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
